<h1 mat-dialog-title>
    {{title}}
</h1>
<div mat-dialog-content>
    <div id="video-player"></div>
</div>
<div class="buttons" mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onConfirm()">Close</button>
</div>
